import TrailwiseEventBus from "./TrailwiseEventBus";
import { TwuidSearchResult, TwuidSearchSource } from "./TwuidSearchContracts";

export class TwuidSearchService {
    private readonly _apiUrl: string = "/api/twuidsearch";

    public search(query: string, source: TwuidSearchSource): Promise<TwuidSearchResult> {
        const trimmedQuery = (query || "").trim();
        return new Promise<TwuidSearchResult>((resolve, reject) => {
            $.ajax({
                url: this._apiUrl,
                data: { query: trimmedQuery },
                dataType: "json"
            })
                .done((json: TwuidSearchResult) => {
                    TrailwiseEventBus.twuidSearchSuccess({
                        query: trimmedQuery,
                        result: json,
                        source: source
                    });
                    resolve(json);
                })
                .fail((jqXHR) => {
                    TrailwiseEventBus.twuidSearchFailure({
                        query: trimmedQuery,
                        status: jqXHR?.status,
                        source: source
                    });
                    reject(jqXHR);
                });
        });
    }
}
